import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=055286af&scoped=true&"
import script from "./forgotPassword.vue?vue&type=script&lang=js&"
export * from "./forgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=055286af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055286af",
  null
  
)

export default component.exports